<template>
  <div class="form-row">
    <div class="form-group col-12 col-md-4">
      <label for="logradouro">Nome</label>
      <input type="text" class="form-control form-control-lg" v-model="partner.Nome" required placeholder="Nome do Avalista">
    </div>
    <div class="form-group col-12 col-md-4">
      <label for="inputPassword4">CPF</label>
      <input type="text" class="form-control form-control-lg" v-model="partner.Cpf" required pattern="\d{3}\.\d{3}\.\d{3}-\d{2}" v-mask="'cpf'" placeholder="CPF">
    </div>
    <div class="form-group col-12 col-md-4">
      <label for="DataNascimento">Data de Nascimento</label>
      <input name="DataNascimento" type="text" class="form-control form-control-lg" v-model="partner.DataNascimento" placeholder="__/__/____" v-mask="'date'" required>
    </div>
    <div class="form-group col-12 col-md-4">
      <label for="Celular">Celular</label>
      <input name="Celular" type="text" class="form-control form-control-lg" v-model="partner.Celular" placeholder="" v-mask="'phone'" required>
    </div>
    <div class="form-group col-12 col-md-8">
      <label for="Email">Email</label>
      <input name="Email" type="email" class="form-control form-control-lg" v-model="partner.Email" placeholder="" required>
    </div>
    <div class="form-group col-12 col-md-6">
      <label for="complemento">Escolaridade</label>
      <at-select size="large" v-model="partner.Escolaridade" placeholder="Escolaridade">
        <at-option v-for="(escolaridade, escolaridadeIndex) in optionsEscolaridade" :key="`escolaridadeOptions${escolaridadeIndex}`" :value="escolaridade.value">{{escolaridade.label}}</at-option>
      </at-select>
    </div>
    <div class="form-group col-12 col-md-6">
      <label for="complemento">Estado Cívil</label>
      <at-select size="large" v-model="partner.EstadoCivil" placeholder="Estado Cívil" :disabled="partner.EstadoCivil === 2 || partner.EstadoCivil === 5">
        <at-option v-for="(marital, maritalIndex) in optionsMarital" :key="`maritalOptions${maritalIndex}`" :value="marital.value">{{marital.label}}</at-option>
      </at-select>
    </div>
    <div class="form-row noSpace col-12" v-if="partner.EstadoCivil === 2 || partner.EstadoCivil === 5">
      <div class="form-group col-12 col-md-4">
        <label for="NomeConjuge">Nome do cônjuge</label>
        <input type="text" name="NomeConjuge" class="form-control form-control-lg" v-model="partner.NomeConjuge" placeholder="Nome do Cônjuge" required/>
      </div>
      <div class="form-group col-12 col-md-4">
        <label for="CpfConjuge">Cpf do cônjuge</label>
        <input type="text" class="form-control form-control-lg" v-model="partner.CpfConjuge" pattern="\d{3}\.\d{3}\.\d{3}-\d{2}" v-mask="'cpf'" placeholder="CPF do Cônjuge" required/>
      </div>
      <div class="form-group col-12 col-md-4">
        <label for="DataNascimentoConjugue">Data de Nascimento do cônjuge</label>
        <input name="DataNascimentoConjuge" type="text" class="form-control form-control-lg" v-model="partner.DataNascimentoConjuge" placeholder="__/__/____" v-mask="'date'" required>
      </div>
      <div class="form-group col-12 col-md-4">
        <label for="CelularConjuge">Celular do cônjuge</label>
        <input name="CelularConjuge" type="text" class="form-control form-control-lg" v-model="partner.CelularConjuge" placeholder="" v-mask="'phone'" required>
      </div>
      <div class="form-group col-12 col-md-8">
        <label for="EmailConjuge">Email do cônjuge</label>
        <input name="EmailConjuge" type="text" class="form-control form-control-lg" v-model="partner.EmailConjuge" placeholder="" required>
      </div>
      <div class="form-group col-12 col-md-12">
      <label for="complemento">Escolaridade do cônjuge</label>
      <at-select size="large" v-model="partner.EscolaridadeConjuge" placeholder="Escolaridade">
        <at-option v-for="(escolaridade, escolaridadeIndex) in optionsEscolaridade" :key="`escolaridadeOptions${escolaridadeIndex}`" :value="escolaridade.value">{{escolaridade.label}}</at-option>
      </at-select>
      </div>
    </div>
    <div class="form-group col-12 col-md-6">
      <label for="Facebook">Facebook</label>
      <input type="text" class="form-control form-control-lg" v-model="partner.Facebook" placeholder="Ex: facebook.com/iouu">
    </div>
    <div class="form-group col-12 col-md-6">
      <label for="Linkedin">Linkedin</label>
      <input type="text" class="form-control form-control-lg" v-model="partner.Linkedin" placeholder="Ex: linkedin.com/in/iouu/">
    </div>
  </div>
</template>

<style scoped lang="scss">
.form-row {
  margin-bottom: 2.5rem;
}

.form-row {
  &.noSpace {
    margin-bottom: 0 !important;
  }
}
</style>

<script>
export default {
  props: {
    partner: { required: true, type: Object }
  },
  data() {
    return {
      optionsEscolaridade: [
        { value: 1, label: "Ensino Fundamental Incompleto" },
        { value: 2, label: "Ensino Fundamental Completo" },
        { value: 3, label: "Ensino Médio Incompleto" },
        { value: 4, label: "Ensino Médio Completo" },
        { value: 5, label: "Ensino Superior Incompleto" },
        { value: 6, label: "Ensino Superior Completo" },
        { value: 7, label: "Pós-Graduação" }
      ],
      optionsMarital: [
        { value: 1, label: "Solteiro (a)" },
        { value: 2, label: "Casado (a)" },
        { value: 3, label: "Divorciado (a)" },
        { value: 4, label: "Viúvo (a)" },
        { value: 5, label: "União Estável" }
      ]
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/components/AdditionalInformationPeerToPeer/GuarantorsStep/PersonFields.vue